import React, { useState } from "react";

const ModalComponent = ({ isOpen, close, children }) => {
  if (!isOpen) return null;

  return (
    <div className="c-modal-overlay">
      <div className="c-modal">
        <button className="c-close-btn" onClick={close} title="Cerrar">
          ×
        </button>        
        {children}
      </div>
    </div>
  );
};

export default ModalComponent;